import * as React from "react";
import classes from "./CustomTextField.module.scss";
import classNames from "classnames";
import {
  ForwardedRef,
  InputHTMLAttributes,
  LegacyRef,
  TextareaHTMLAttributes,
} from "react";

// eslint-disable-next-line react/display-name
type CustomTextFieldElement = HTMLInputElement | HTMLTextAreaElement;

type CommonProps = {
  labelName?: string;
  errorMessage?: string;
  isTextAreaDisabled?: boolean;
  isLicense?: boolean;
  children?: React.ReactNode[] | React.ReactNode;
};

type CustomTextFieldProps =
  | (CommonProps & { isTextarea?: false } & InputHTMLAttributes<HTMLInputElement>)
  | (CommonProps & { isTextarea: true } & TextareaHTMLAttributes<HTMLTextAreaElement>);

export const CustomTextField = React.forwardRef<
  CustomTextFieldElement,
  CustomTextFieldProps
>(
  (props, ref: ForwardedRef<CustomTextFieldElement>) => {
    const {
      labelName,
      errorMessage,
      children,
      isTextAreaDisabled,
      isTextarea,
      isLicense,
      ...rest
    } = props;

    const shouldRenderLabel = Boolean(labelName && labelName.trim().length > 0);

    const commonFieldClassName = classNames(classes.customTextfield, {
      [classes.error]: errorMessage,
      [classes.license]: isLicense,
    });

    return (
      <div className={classes.customTextFieldContainer}>
        {shouldRenderLabel && (
          <label
            className={classNames(classes.customLabel, {
              [classes.license]: isLicense,
            })}
          >
            {labelName}
          </label>
        )}
        {!children && (
          <div className={classes.textareaContainer}>
            {isTextarea ? (
              <textarea
                readOnly={isTextAreaDisabled}
                spellCheck="false"
                className={commonFieldClassName}
                {...(rest as TextareaHTMLAttributes<HTMLTextAreaElement>)}
                ref={ref as LegacyRef<HTMLTextAreaElement>}
              />
            ) : (
              <input
                readOnly={isTextAreaDisabled}
                className={commonFieldClassName}
                {...(rest as InputHTMLAttributes<HTMLInputElement>)}
                ref={ref as LegacyRef<HTMLInputElement>}
              />
            )}
            {errorMessage && (
              <h3 className={classes.errorText}>{errorMessage}</h3>
            )}
          </div>
        )}
        {children && (
          <div
            className={classNames(classes.customTextfield, classes.second, {
              [classes.error]: errorMessage,
            })}
          >
            {children}
          </div>
        )}
      </div>
    );
  },
);
